const SPOTS = [
  ["rim", 50, 13], ["paint", 50, 33], ["midrange", 50, 54], ["corner3", 6, 16], ["corner3", 94, 16],
  ["wing3", 13, 62], ["wing3", 87, 62], ["top3", 50, 84],
];
const LABEL = { rim: "Rim", paint: "Paint", midrange: "Mid", corner3: "Corner 3", wing3: "Wing 3", top3: "Top 3" };

export const zonesFromSeason = (z) => {
  if (!z) return {};
  return Object.fromEntries(Object.entries(z).map(([k, v]) => [k, v?.a ? (100 * v.m) / v.a : null]));
};

const tone = (v) =>
  v === null || v === undefined ? "bg-[#162032] text-slate-400 ring-[#1E293B]"
    : v >= 50 ? "bg-[#39FF14] text-[#0A0E1A] ring-[#39FF14] shadow-[0_0_24px_rgba(57,255,20,0.45)]"
    : v >= 35 ? "bg-[#00E5FF]/20 text-[#00E5FF] ring-[#00E5FF]/60"
    : "bg-[#FF3B30]/20 text-red-200 ring-[#FF3B30]/60";

export const ShotZones = ({ zones = {}, testid = "shot-zone-court" }) => (
  <div data-testid={testid} className="relative mx-auto aspect-[500/470] w-full max-w-md">
    <svg viewBox="0 0 500 470" className="absolute inset-0 h-full w-full" fill="none" stroke="currentColor">
      <g className="text-slate-600" strokeWidth="2">
        <rect x="2" y="2" width="496" height="466" rx="6" />
        <rect x="170" y="2" width="160" height="188" />
        <circle cx="250" cy="190" r="60" />
        <path d="M30 2 L30 140 A 237 237 0 0 0 470 140 L470 2" className="text-[#39FF14]/50" stroke="currentColor" />
        <path d="M210 52 A 40 40 0 0 0 290 52" />
        <line x1="220" y1="40" x2="280" y2="40" strokeWidth="3" />
        <circle cx="250" cy="52" r="8" className="text-[#FF3B30]" stroke="currentColor" />
      </g>
    </svg>
    {SPOTS.map(([k, x, y], i) => (
      <div key={`${k}-${i}`} style={{ left: `${x}%`, top: `${y}%` }} className="absolute -translate-x-1/2 -translate-y-1/2 text-center">
        <div className={`rounded-lg px-2 py-1 font-mono-gd text-xs font-bold ring-1 ${tone(zones[k])}`}>
          {zones[k] === null || zones[k] === undefined ? "—" : `${Math.round(zones[k])}%`}
        </div>
        <p className="mt-1 hidden whitespace-nowrap font-mono-gd text-[10px] uppercase tracking-wider text-slate-400 sm:block">{LABEL[k]}</p>
      </div>
    ))}
  </div>
);
